import React, {Fragment, useState} from "react";
import {Accordion, Icon} from "semantic-ui-react";

export const SidePanel = ({ panels }) => {
  const panelDefaultState = panels.reduce(
    (state, panel) => ({ ...state, [panel.key]: !!panel.active }),
    {}
  );
  const [active, setActive] = useState(panelDefaultState);

  function panelActive(p) {
    return active.hasOwnProperty(p.key) ? active[p.key] : p.active;
  }

  function togglePanel(p) {
    return () =>
      setActive({
        ...active,
        [p.key]: !(active.hasOwnProperty(p.key) ? active[p.key] : p.active)
      });
  }

  return (
    <div className="o-side-panel">
      <Accordion fluid>
        {panels.map(p => (
          <Fragment key={p.key}>
            <Accordion.Title active={panelActive(p)} onClick={togglePanel(p)}>
              {p.title}
              <Icon name="dropdown" className="pull-right" />
            </Accordion.Title>
            <Accordion.Content active={panelActive(p)}>
              {p.content}
            </Accordion.Content>
          </Fragment>
        ))}
      </Accordion>
    </div>
  );
};
